<template>
	<modal :id="ref" :ref="ref" :closeProp="close" title="Elemento del Form">
		<form :id="refForm" :ref="refForm">
			<form-input
				name="label"
				id="label"
				label="Etichetta"
				:value="getValue('label')"
			></form-input>

			<form-input
				name="placeholder"
				id="placeholder"
				label="Placeholder"
				:value="getValue('placeholder')"
			></form-input>

			<form-input
				name="name"
				id="name"
				label="Nome"
				:value="getValue('name')"
				small="Non deve contenere spazi o simboli"
				required
			></form-input>

			<form-select
				label="Tipo"
				name="type"
				id="type"
				:options="formTypes"
				:value="getValue('type')"
				required
			></form-select>

			<form-input
				name="value"
				id="value"
				label="Valore Predefinito"
				:value="getValue('value')"
			></form-input>

			<form-textarea
				name="options"
				id="options"
				placeholder="valore|etichetta"
				label="Opzioni"
				small="Devi compilarlo nel caso di un tipo di campo: Checkbox, Radio, Select"
				:value="getValue('options')"
			></form-textarea>
		</form>

		<template v-slot:footer>
			<btn type="success" :icon="['far', 'check']" title="Salva" :action="submitForm"></btn>
		</template>
	</modal>
</template>

<script>
export default {
	data: () => ({
		ref: 'formitems_modal',
		refForm: '',
		urlupdate: '',
		id: '',
		datas: {},
	}),
	props: {
		urlstore: {
			type: String,
			default: '',
			required: true,
		},
		reftable: {
			type: String,
			default: '',
			required: false,
		},
		formTypes: {
			type: Array,
			default: () => [],
			required: false,
		},
	},
	created: function () {
		this.refForm = this.ref + 'DataForm'
	},
	methods: {
		close: function () {
			this.assignData({})
			this.urlupdate = ''

			this.$refs[this.ref].close()
		},
		open: function (data) {
			if (!!data && typeof data === 'object') {
				if (!!data.urlupdate) this.urlupdate = data.urlupdate
				if (!!data.datas) this.assignData(data.datas)
			} else if (!!data && Array.isArray(data)) {
				this.assignData(data)
			} else {
				this.assignData({})
			}

			this.$refs[this.ref].open()
		},
		getValue: function (key, defaultValue) {
			if (key === '') return this.datas
			else if (!!this.datas[key]) return this.datas[key]
			else if (this.datas[key] === 0 || this.datas[key] === '0' || this.datas[key] === false)
				return this.datas[key]
			else if (!!defaultValue) return defaultValue
			else return ''
		},
		getAction: function () {
			return !!this.id ? this.urlupdate : this.urlstore
		},
		getMethod: function () {
			return !!this.id ? 'PATCH' : 'POST'
		},
		assignData: function (datas) {
			if (!datas) return false

			if (!!Object.keys(datas).length) {
				this.datas = datas
				if (!!datas.id) this.id = datas.id
			} else {
				this.datas = {}
				this.id = ''
			}
		},
		submitForm: function () {
			return this.$root.request(
				this,
				this.getAction(),
				this.getMethod(),
				this.$root.getParamsFromForm(this.$refs[this.refForm]),
				this.submitFormCallback
			)
		},
		submitFormCallback: function (data) {
			if (!!this.reftable) this.$root.tableRefresh(this.reftable)

			this.close()
		},
	},
}
</script>
